import { createAction } from 'redux-actions';

export const requestGetClientsListAction = createAction('REQUEST/GET_CLIENTS_LIST');
export const setClientsListStatusAction = createAction('SET/CLIENTS_LIST_STATUS');
export const setClientsListSendDateAction = createAction('SET/SEND_DATE_STATUS');
export const setTeamListSendDateAction = createAction('SET/SEND_DATE_STATUS');
